import { joinPaths } from '@ifixit/helpers';
import { ComponentProps } from 'react';

export type StaticAssetProps = {
   path: string;
   alt: string;
};

export function StaticImage({ path, alt, ...props }: StaticAssetProps & ComponentProps<'img'>) {
   const joinedPath = joinPaths('static', path);
   const url = new URL(joinedPath, 'https://assets.cdn.ifixit.com');
   return <img data-slot="static-image" src={url.href} alt={alt || path} {...props} />;
}
